import React, { useEffect, useState } from "react";
import "../../purchasedAssorts.scss";
import "../style.scss";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import useLocaleByLanguage from "../../../../../utils/hooks/useLocaleByLanguage";
import { Ticket } from "../../../../models/Ticket";
import { Exercise } from "../../../../models/Exercise";
import useMethodAccount from "../../hooks/useMethodAccount";
import { TbTicket } from "react-icons/tb";
import useFacility from "../../../../../utils/hooks/useFacility";
import useDesktopSize from "../../../../../utils/hooks/useDesktopSize";
import ReservationStatusAlerts from "./ReservationStatusAlerts";
import ReservationActions from "./ReservationActions";
import ReservationDetails from "./ReservationDetails";
import AddToGoogleCalendar from "../../../shared/CalendarIntegration/AddToGoogleCalendar";

interface IProps {
  ticket: Ticket;
  exercise: Exercise;
  onRefreshTickets: () => void;
}

const SingleReservation: React.FC<IProps> = ({ ticket, exercise, onRefreshTickets }) => {
  const { resignExercise } = useMethodAccount();
  const [cancelReservation, setCancelReservation] = useState<boolean>(true);
  const { t } = useTranslation();
  const locale = useLocaleByLanguage();
  const [now, setNow] = useState(Date.now());
  const facilityIds = useFacility();
  const showAllStatuses = facilityIds === "1243" || facilityIds === "1241";
  const isDesktop = useDesktopSize();

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(Date.now());
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  const exerciseStartTime = Number(exercise.startTime);
  console.log()

  const handleResign = async () => {
    await resignExercise(exercise, onRefreshTickets);
  };

  if (isDesktop) {
    return (
      <div className="purchased-assort">
        <div className="purchased-assort_left">
          <div className="purchased-assort_startIcon">
            <b>{format(exercise.startTime, "MMM", { locale: locale })}</b>
            <b>{format(exercise.startTime, "d", { locale: locale })}</b>
          </div>

          <div className="purchased-assort_body">
            <ReservationStatusAlerts exercise={exercise} showAllStatuses={showAllStatuses} t={t} />

            <ReservationDetails exercise={exercise} locale={locale} isDesktop={isDesktop} />

            <h5>{exercise.name}</h5>

            <span className="purchased-assort_body__details">
              <TbTicket /> {ticket.name}
            </span>
          </div>
        </div>

        <div className="purchased-assort_action">
          <ReservationActions
            cancelReservation={cancelReservation}
            setCancelReservation={setCancelReservation}
            onResign={handleResign}
            exerciseStartTime={exerciseStartTime}
            now={now}
            t={t}
            isDesktop={isDesktop}
            ticket={ticket}
          />
        </div>
      </div>
    );
  }

  // Wersja mobilna
  return (
    <div className="purchased-assort__mobile purchased-assort">
      <div className="purchased-assort_body__mobile">
        <ReservationStatusAlerts exercise={exercise} showAllStatuses={showAllStatuses} t={t} />

        <ReservationDetails exercise={exercise} locale={locale} isDesktop={isDesktop} />

        <h5>{exercise.name}</h5>

        <span className="purchased-assort_body__details__mobile">
          <TbTicket /> {ticket.name}
        </span>

        <b className="purchased-assort_body__details__mobile">
          <AddToGoogleCalendar exercise={exercise} variant="text" color="secondary" />
        </b>
      </div>

      <div className="purchased-assort_action">
        <ReservationActions
          cancelReservation={cancelReservation}
          setCancelReservation={setCancelReservation}
          onResign={handleResign}
          exerciseStartTime={exerciseStartTime}
          now={now}
          t={t}
          isDesktop={isDesktop}
          ticket={ticket}
        />
      </div>
    </div>
  );
};

export default SingleReservation;
